// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"eb44843b","455":"31ec3d76","977":"64446706"}[chunkId] + ".chunk.js";
};